import { render, staticRenderFns } from "./editScratchMould.vue?vue&type=template&id=074c2de5&scoped=true"
import script from "./editScratchMould.vue?vue&type=script&lang=js"
export * from "./editScratchMould.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c2de5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074c2de5')) {
      api.createRecord('074c2de5', component.options)
    } else {
      api.reload('074c2de5', component.options)
    }
    module.hot.accept("./editScratchMould.vue?vue&type=template&id=074c2de5&scoped=true", function () {
      api.rerender('074c2de5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/editScratchMould.vue"
export default component.exports